import api from "@/services/api";
import { formatDateToString } from "@/utils";

const { get, patch, post } = api.getPrefixedMethods("patients");

const SUBSTATUS_TARGET_PARAMS = {
  submission: "order_key",
  document: "intake_document_key",
  order: "intake_order_id",
};

export const patientService = {
  /** Roster substatus chips for one case page (LAM-5685), resolved exactly as its grid row. */
  getCaseSubstatusTags(entityType, entityId) {
    return get("substatus-tags", { params: { [SUBSTATUS_TARGET_PARAMS[entityType]]: entityId } });
  },
  search({ firstName, lastName, phoneNumber, dob, address, externalId }, clientCompany) {
    return get("", {
      params: {
        first_name: firstName,
        last_name: lastName,
        phone_number: phoneNumber,
        dob: dob ? formatDateToString(dob) : null,
        address: address,
        external_id: externalId,
        client_company: clientCompany,
      },
    });
  },
  patchPatient(
    id,
    {
      firstName,
      lastName,
      phoneNumber,
      dob,
      middleName,
      suffix,
      externalId,
      extraData,
      address,
      city,
      state,
      zip,
      gender,
    }
  ) {
    if (dob instanceof Date) {
      dob = formatDateToString(dob);
    }
    return patch(`${id}/`, {
      firstName,
      lastName,
      phoneNumber,
      dob,
      middleName,
      suffix,
      externalId,
      extraData,
      address,
      city,
      state,
      zip,
      gender,
    });
  },
  postPatient({ firstName, lastName, phoneNumber, dob, clientCompany, middleName, suffix }) {
    return post("", {
      firstName,
      lastName,
      phoneNumber,
      dob: dob ? formatDateToString(dob) : null,
      clientCompany,
      middleName,
      suffix,
    });
  },
  updateExternalId(id, externalId) {
    return patch(`${id}/external-id/`, {
      external_id: externalId,
    });
  },
  getByExternalId(externalId) {
    return get(`external-id/${encodeURIComponent(externalId)}/`);
  },
  searchPatientsByMRN(mrn) {
    // RESTful endpoint with exact match for MRN (external_id)
    return get("", { params: { external_id: mrn, external_id_exact: true } });
  },
  getPatientsCount() {
    return get("", { params: { count_only: true } });
  },
  // Roster actions take the submission fields themselves, not an order key — they work the same on
  // Create Submission (no order exists yet) as on a saved order's form.
  reconcilePatientRoster(submissionFields) {
    return post("roster/reconcile/", submissionFields);
  },
  addPatientToRoster(submissionFields) {
    return post("roster/add/", submissionFields);
  },
  applyPatientRosterField(submissionFields, field) {
    return post("roster/apply-field/", { ...submissionFields, field });
  },
  savePatientInsuranceToRoster(submissionFields) {
    return post("roster/save-insurance/", submissionFields);
  },
  getPatientInsurances(patientId) {
    return get(`${patientId}/insurances/`);
  },
};
